import React, { ReactNode, useState } from 'react';
import { IconButton, Tooltip as MuiTooltip } from '@mui/material';
import { ReactComponent as InfoIcon } from '../../assets/common/info_icon.svg';

export const AppTooltip = ({ title }: { title: ReactNode }) => {
    const [openTooltip, setOpenTooltip] = useState(false);

    const handleTooltipClose = () => {
        setOpenTooltip(false);
    };

    const handleTooltipOpen = () => {
        setOpenTooltip(true);
    };
    return (
        <MuiTooltip
            onClose={handleTooltipClose}
            open={openTooltip}
            disableTouchListener
            onMouseEnter={handleTooltipOpen}
            onClick={handleTooltipOpen}
            placement="top"
            componentsProps={{
                tooltip: {
                    sx: {
                        minWidth: '320px',
                        backgroundColor: '#fff',
                        borderRadius: '20px',
                        filter: 'drop-shadow(0px 10px 30px rgba(132, 145, 160, 0.10))',
                    },
                },
            }}
            title={title}
        >
            <IconButton
                sx={{
                    padding: 0,
                    opacity: 0.6,
                    '&:hover': {
                        opacity: 1,
                        backgroundColor: 'transparent',
                        cursor: 'pointer',
                    },
                }}
            >
                <InfoIcon />
            </IconButton>
        </MuiTooltip>
    );
};
